import dayjs from 'dayjs';

export const checkQuizDateAnsObj = (value) => {
  if (Object.prototype.toString.call(value) === "[object Date]") {
    let date = new Date(value);
    return dayjs(date).format('DD-MMM-YYYY') + 'T00:00:00.000Z';
  }
  return value;
};
